import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { ValueSort } from "../../../shared/sort-funcions/value-sort";
import { RadioModel } from "../../model/radio.model";
import { PersonalDataService } from "../../service/personal-data.service";

@Component({
  selector: "app-document-issuing",
  templateUrl: "./document-issuing.component.html",
  styleUrls: ["./document-issuing.component.scss"],
})
export class DocumentIssuingComponent
  extends DefaultPageComponent
  implements OnInit
{
  selectedItem = "";
  selectedName = "";
  headerId = "document-issuing";
  textSearch: string;
  fieldSearch = "value";
  titlePage = "Dados pessoais";
  buttonEnable = false;
  documentIssuing = new Array<RadioModel>();
  @ViewChild("content") content: ElementRef;
  startStage = "";
  endStage = "";
  showRetry = false;
  loading = true;
  titleLabel = "Qual é o órgão expedidor";
  titleLabelPage = `${this.titleLabel}?`;
  dataDomain: RadioModel[];
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  sendAnalyticsFirstView = false;
  idLabelIssuingAgency = "labelIssuingAgency";
  idInputIssuingAgency = "inputIssuingAgency";
  idRadioIssuingAgency = "radioIssuingAgency";
  idButtonIssuingAgency = "buttonIssuingAgency";
  idRetryIssuingAgency = "retryIssuingAgency";
  constructor(
    private personalDataService: PersonalDataService,
    private title: Title,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public domainFactory: DomainFactoryService,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.configureDomain(null, DomainDataType.DocumentIssuing);
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.getDomainIssuing();
    this.setTitleLabel();
    this.editFieldInvest(
      "orgao_expedidor_codigo",
      "issuingAgency",
      "personalData"
    );
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "personal-data";

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PERSONAL
    ) {
      this.startStage = "4";
      this.endStage = "11";
    } else {
      this.startStage = (
        track.getIndexPage(this.headerId, path) - 1
      ).toString();
      this.endStage = (track.getTotalPage(path) - 1).toString();
    }
  }

  setTitleLabel() {
    const documentTypeName = this.formatTypeDocumentName(
      this.personalDataService.getDocumentTypeData()
    );
    if (documentTypeName) {
      const text = documentTypeName === "CNH" ? "da sua" : "do seu";
      this.titleLabelPage = `${this.titleLabel} ${text} ${documentTypeName}?`;
    }
  }

  formatTypeDocumentName(typeDocument: string) {
    switch (typeDocument) {
      case "551":
        return "RG";
      case "552":
        return "RNE";
      case "558":
        return "CNH";
      default:
        return "";
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();

    if (this.sendAnalyticsFirstView) {
      this.analyticsData();
      this.sendTrackGA4LoadPage();
    }
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.documentIssuing;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathOrgaoExpedidor,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    const paramComplementary = {
      detail: this.formatTypeDocumentName(
        this.personalDataService.getDocumentTypeData()
      ).toLowerCase(),
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  sendTrackGA4LoadPageError() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameAlert,
      custom_path: this.analyticsPageGA4.customPathOrgaoExpedidor,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };
    const paramComplementary = {
      detail: "tipo:tela",
      description: this.analyticsPageGA4.titleError,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    this.sendAnalyticsFirstView = true;
    this.personalDataService.setDocumentIssuingName(this.selectedName);
    this.personalDataService.setDocumentIssuing(this.selectedItem);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.documentIssuing,
    };

    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  ionViewDidLeave() {
    this.textSearch = "";
    this.documentIssuing = this.orderList(
      this.documentIssuing,
      this.selectedItem
    );
    this.ariaHidden = true;
  }

  getDomainIssuing() {
    this.domainFactory
      .getDomainService(this.domainOrigin)
      .getDomains(this.domainDataType)
      .then((dominios) => {
        if (dominios?.length > 0) {
          this.documentIssuing = this.orderList(
            dominios,
            this.journeyService.registratioJourney.data.personalData
              ?.issuingAgency
          );
          this.showRetry = false;
          this.analyticsData();
          this.sendTrackGA4LoadPage();
        } else {
          this.showRetry = true;
          this.loading = false;
          this.headerFocus();
          this.sendTrackGA4LoadPageError();
        }
      })
      .catch(() => {
        this.showRetry = true;
        this.loading = false;
        this.sendTrackGA4LoadPageError();
      })
      .finally(() => {
        this.loading = false;
        this.headerFocus();
      });
  }

  orderList(data: RadioModel[], selectedItem: string): RadioModel[] {
    if (selectedItem !== "") {
      const dataOrder = data;
      dataOrder.sort(ValueSort.compareFn);
      return [
        ...dataOrder.filter((value) => value.key === selectedItem),
        ...dataOrder.filter((value) => value.key !== selectedItem),
      ];
    }
    return data;
  }

  setEditPageRegistratio() {
    if (
      this.journeyService.registratioJourney.data.personalData.issuingAgency
    ) {
      this.selectedItem =
        this.journeyService.registratioJourney.data.personalData.issuingAgency;
      this.selectedName =
        this.journeyService.registratioJourney.data.personalData.issuingAgencyName;
    }
  }

  scrollContentToTop() {
    setTimeout(() => this.content?.nativeElement.scrollTo(0, 0), 200);
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

  changeValue() {
    this.documentIssuing = this.orderList(
      this.documentIssuing,
      this.selectedItem
    );
  }
}
